const getters = {
  multimedias: (state) => state.multimedias,
}

export default getters
